import type { BillingPayer } from '$lib/api/types.gen';

export function domainErrorKind(error: unknown): string | undefined {
	if (!error || typeof error !== 'object' || !Object.hasOwn(error, 'kind')) {
		return undefined;
	}

	const kind = (error as { kind?: unknown }).kind;
	return typeof kind === 'string' ? kind : undefined;
}

/**
 * What a `BILLING_NOT_PROVISIONED` refusal says beyond its kind: which payer has no contract (not
 * necessarily the one that was asked about) and whether self-serve setup can provision it.
 * Absent where the refusal named no payer, or the body is not a billing refusal.
 */
export type BillingRefusalDetails = { payer?: BillingPayer; setupAvailable?: boolean };

export function billingRefusalDetails(error: unknown): BillingRefusalDetails {
	if (!error || typeof error !== 'object') return {};
	const { payer, setup_available } = error as { payer?: unknown; setup_available?: unknown };
	const named =
		payer &&
		typeof payer === 'object' &&
		((payer as { type?: unknown }).type === 'org' ||
			(payer as { type?: unknown }).type === 'user') &&
		typeof (payer as { id?: unknown }).id === 'string'
			? (payer as BillingPayer)
			: undefined;
	return {
		payer: named,
		setupAvailable: typeof setup_available === 'boolean' ? setup_available : undefined,
	};
}
